<template>
    <div>

        <div class="columns" v-if="product !== null">
            <div class="column is-7">
                <product-form :product="product" @saved="reloadProduct"></product-form>
            </div>
            <div class="column is-5" style="border-left: 1px solid #e1e1e1; padding-left: 1.5rem;">

                <product-parts :product-id="product.id"></product-parts>

                <br/>

                <product-items :product-id="product.id"></product-items>

                <br/>

                <product-tags :product-id="product.id"></product-tags>

                <br/>

                <product-bundles :product-id="product.id"></product-bundles>

                <br/>

                <product-categories :product-id="product.id"></product-categories>
            </div>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss">
    .field:not(:last-child) {
        margin-bottom: 0.75rem;
    }

    .product-field {
        margin-bottom: 0.5rem;
        &:last-child {
            margin-bottom: 1rem;
        }
    }

    .product-link {
        padding-bottom: 1.5rem;
        border-bottom: 1px solid #e1e1e1;
    }
</style>

<script>
    import {mapGetters} from "vuex"
    export default {
        mounted() {
            this.reloadProduct()
        },
        data() {
            return {
                product_id: parseInt(this.$route.params.id),
                product: null
            }
        },
        computed: Object.assign({}, mapGetters(['products', 'bundles', 'categories', 'items', 'tags'])),
        methods: {
            changeProduct(newId, oldId) {
                this.product_id = parseInt(newId)
                this.reloadProduct()
            },
            reloadProduct() {
                this.product = null;
                setTimeout(() => {
                    this.product = this.$store.state.products.all.find(product => product.id === this.product_id)
                })
            }
        },
        watch: {
            '$route.params.id': 'changeProduct'
        }
    };
</script>



// WEBPACK FOOTER //
// ProductEdit.vue?bc02d4aa